import React, {useState} from 'react';
import {SelectButton} from "primereact/selectbutton";

import {AppContext} from "../../HomePage";
import ProductSearchDiagnostics from "./ProductSearchDiagnostics";
import ProductSiteSearchDiagnostics from "./ProductSiteSearchDiagnostics";

// The Search Diagnostics tab: the search engine view (unchanged) or the in-site search
// view. Kept out of ProductDetail, which is already very large.
const ProductSearchDiagnosticsTabs = ({selectedProduct}) => {

    const {t} = React.useContext(AppContext);
    const [source, setSource] = useState('engine');
    const options = [
        {label: t('search_diagnostics.source_engine'), value: 'engine'},
        {label: t('search_diagnostics.source_site'), value: 'site'},
    ];

    return <div>
        {/* Clicking the selected option would clear it; keep one always selected. */}
        <SelectButton value={source} options={options} style={{marginBottom: '1em'}}
                      onChange={(e) => e.value && setSource(e.value)}/>
        {source === 'engine'
            ? <ProductSearchDiagnostics selectedProduct={selectedProduct}/>
            : <ProductSiteSearchDiagnostics selectedProduct={selectedProduct}/>}
    </div>;
};

export default ProductSearchDiagnosticsTabs;
